"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChartComponent = exports.ChartType = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/ChartStyles");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var ChartType;
(function (ChartType) {
    ChartType[ChartType["Gains"] = 0] = "Gains";
    ChartType[ChartType["CumulativeCapture"] = 1] = "CumulativeCapture";
    ChartType[ChartType["ROCCurve"] = 2] = "ROCCurve";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
var DEFAULT_POINT_RADIUS = 3;
var HIGHLIGHT_POINT_RADIUS = 9;
var HIGHLIGHT_POINT_COLOR = colors.textLinkActive;
var DEFAULT_FONT_SIZE = '12px';
var LineChartComponent = function (props) {
    var _a, _b;
    var coordinates = props.coordinates, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, degree45Line = props.degree45Line, highlight = props.highlight, legend = props.legend, drawPoint = props.drawPoint;
    var chartRef = react_1.useRef(null);
    var height = (_a = props.height) !== null && _a !== void 0 ? _a : sizes.heightTall;
    var width = (_b = props.width) !== null && _b !== void 0 ? _b : sizes.widthVeryWide;
    var margin = sizes.chartMargins;
    var chartHeight = height - margin.top - margin.bottom;
    var chartWidth = width - margin.left - margin.right;
    var xAxisTranslate = height - margin.bottom;
    var yAxisTranslate = margin.left;
    var maxYValue = Math.max.apply(Math, coordinates.map(function (coordinate) { return coordinate[1]; }));
    // Create scales
    var xScale = d3
        .scaleLinear()
        .domain([0, 1])
        .range([margin.left, width - margin.right]);
    var yScale = d3
        .scaleLinear()
        .domain([0, Math.ceil(maxYValue * 10) / 10])
        .range([height - margin.bottom, margin.top]);
    var drawAxes = react_1.useCallback(function (svg) {
        var yAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(yAxis, 5);
        utils_1.drawAxis(svg, yAxis, yAxisTranslate, 0, DEFAULT_FONT_SIZE, styles.barAxisText);
        var xAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(xAxis, sizes.defaultNumTicks, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, xAxis, 0, xAxisTranslate, DEFAULT_FONT_SIZE, styles.barAxisText);
    }, [xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawBackgroundGrid = react_1.useCallback(function (svg) {
        var backgroundYAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(backgroundYAxis, 5, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundYAxis, yAxisTranslate, 0);
        var backgroundXAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(backgroundXAxis, sizes.defaultNumTicks, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundXAxis, 0, xAxisTranslate);
    }, [chartWidth, xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawLines = react_1.useCallback(function (svg) {
        var line = d3
            .line()
            .x(function (d) {
            return xScale(d[0]) || 0;
        })
            .y(function (d) {
            return yScale(d[1]) || 0;
        })
            .curve(d3.curveMonotoneX);
        svg
            .append('path')
            .datum(coordinates)
            .attr('transform', "translate(0, 0)")
            .attr('d', line)
            .style('fill', 'none')
            .style('stroke', colors.defaultBlue)
            .style('stroke-width', '2');
    }, [coordinates, xScale, yScale]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove();
        var svg = d3.select(chartRef.current).attr('height', height).attr('width', width);
        // draw axes
        var xAxisLabelStartX = chartWidth / 2 + margin.left;
        var xAxisLabelStartY = height;
        utils_1.drawAxisLabel(svg, xAxisLabel || '', xAxisLabelStartX, xAxisLabelStartY, false, DEFAULT_FONT_SIZE, styles.barAxisText);
        var yAxisLabelStartX = 10;
        var yAxisLabelStartY = chartHeight / 2 + margin.top;
        utils_1.drawAxisLabel(svg, yAxisLabel || '', yAxisLabelStartX, yAxisLabelStartY, true, DEFAULT_FONT_SIZE, styles.barAxisText);
        drawAxes(svg);
        drawBackgroundGrid(svg);
        // graph points
        drawLines(svg);
        if (drawPoint !== false) {
            utils_1.drawPoints(svg, coordinates, xScale, yScale, colors.defaultBlue, DEFAULT_POINT_RADIUS);
        }
        if (degree45Line) {
            utils_1.draw45DegreeLine(svg, xScale, yScale);
        }
        if (highlight) {
            utils_1.drawPoints(svg, [highlight], xScale, yScale, HIGHLIGHT_POINT_COLOR, HIGHLIGHT_POINT_RADIUS);
        }
    }, [
        chartHeight,
        chartWidth,
        coordinates,
        drawAxes,
        drawBackgroundGrid,
        drawLines,
        height,
        margin,
        xAxisLabel,
        yAxisLabel,
        degree45Line,
        width,
        xAxisTranslate,
        xScale,
        yAxisTranslate,
        yScale,
        highlight,
        drawPoint,
    ]);
    var renderLegend = function () {
        if (!legend) {
            return null;
        }
        return (React.createElement("div", { className: styles.legend },
            React.createElement("div", { className: styles.legendNoModel }),
            React.createElement("div", { className: styles.legendText }, Localize_1.Messages.NoModel()),
            React.createElement("div", { className: styles.legendValidation }),
            React.createElement("div", { className: styles.legendText }, legend.text)));
    };
    return (React.createElement("div", { className: styles.chartContainer },
        renderLegend(),
        React.createElement("svg", { ref: chartRef })));
};
exports.LineChartComponent = LineChartComponent;
//# sourceMappingURL=LineChartComponent.js.map